/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Already_Have_AccountInputs */

const en_auth_already_have_account = /** @type {(inputs: Auth_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const es_auth_already_have_account = /** @type {(inputs: Auth_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes una cuenta?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Already_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_already_have_account = /** @type {((inputs?: Auth_Already_Have_AccountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Already_Have_AccountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_already_have_account(inputs)
	return en_auth_already_have_account(inputs)
});